import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { checkContactListAccess } from 'services/contactList/checkContactListAccess';
import ContactListFeatures from 'services/contactList/types';
import { IFeatureFlagrResponse } from 'services/featureFlagr';
import { QUERY_FLAGR_KEY } from 'services/searchTrucker/constants';

const useContactListFeatureQuery = (options?: Partial<UseQueryOptions<IFeatureFlagrResponse, Error>>) =>
  useQuery<IFeatureFlagrResponse, Error>({
    queryKey: [QUERY_FLAGR_KEY, ContactListFeatures.CONTACT_LIST],
    queryFn: () => checkContactListAccess(ContactListFeatures.CONTACT_LIST).then((res) => res),
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    gcTime: 0,
    ...options,
  });

export { useContactListFeatureQuery };
